import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-chevron-right-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-chevron-right-svg-icon.component.html',
  styleUrl: './ln-chevron-right-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnChevronRightSvgIconComponent {
  @Input({ required: true }) class!: string;
}
